import requestUtil from "../request-utils.js";
import { getParam } from "./api-params.js";

/**
 * 获取渠道详情
 * @param {Object} channelId
 */
function getChannelInfo(channelId, refresh = false) {
	return new Promise((resolve, reject) => {
		//  补充渠道ID
		channelId = !channelId ? localStorage.getItem("pc_channelId") : channelId;

		// 优先从缓存中获取信息
		let channelInfo = localStorage.getItem("pc_channelInfo");
		if (!refresh && channelInfo && channelInfo.channelId) {
			resolve(JSON.parse(channelInfo));
			return;
		}

		// 缓存中没有信息，则调用接口获取最新数据
		requestUtil.jackyunPost(
			{
				method: "salechannel.detail",
				salechannelId: channelId,
			},
			res => {
				if (res.code === 200) {
					// 保存到缓存
					localStorage.setItem("pc_channelInfo", JSON.stringify(res.result.data));
					resolve(res.result.data);
				} else {
					resolve(null);
				}
			}
		);
	});
}

/**
 * 获取当前结算账户信息
 */
async function getAccountInfo() {
	let paramList = await getParam("defaultAccountId,defaultAccountName");
	// 已经在吉商城配置了结算账户，则直接取配置信息
	if (paramList.defaultAccountId) {
		return {
			accountId: paramList.defaultAccountId,
			accountName: paramList.defaultAccountName,
		};
	}

	// 没有配置的情况，则获取当前渠道的默认结算账户
	let currChannelInfo = localStorage.getItem("pc_channelInfo");
	// 获取渠道默认结算账户
	try {
		let channelDefaultAccountInfo = currChannelInfo.salesSettlementAccountList.find(t => t.isDefault == 1);
		return {
			accountId: channelDefaultAccountInfo.bankaccountId,
			accountName: channelDefaultAccountInfo.bankaccountName,
		};
	} catch (e) {}

	return {
		accountId: "",
		accountName: "",
	};
}

//可以被外部引用的方法
export { getChannelInfo, getAccountInfo };
